import React, { useState, useEffect } from "react";

//Assets
import XIcon from "assets/x-white.png";
import IArrowRounded2 from "assets/i-arrow-rounded-2";

const ImageIndicator = ({ src, alt, currentPosition, position }) => {
  const isSelected = currentPosition === position;

  return (
    <div className={`w-[96px] aspect-square ${isSelected ? "mb-2" : ""}`}>
      <img src={src} alt={alt} className="w-full h-full object-cover" />
    </div>
  );
};

function ModalImages({ listImages, onClose, initialPosition = 1 }) {
  const [position, setPosition] = useState(initialPosition);
  const [img, setImg] = useState(null);

  const renderImage = () => {
    if (listImages?.length) {
      const img = listImages.filter((img, idx) => idx === position);
      if (img?.length) {
        setImg(img[0]);
      }
    } else {
      setImg("");
    }
  };

  const handlePrevImg = () => {
    let newPosition = position;
    if (newPosition > 0) {
      newPosition = newPosition - 1;
    }
    setPosition(newPosition);
  };

  const handleNextImg = () => {
    let newPosition = position;
    if (newPosition < listImages?.length - 1) {
      newPosition = newPosition + 1;
    }
    setPosition(newPosition);
  };

  useEffect(() => {
    renderImage();
  }, [position]);

  return (
    <div className="fixed z-[43] top-0 left-0 w-screen h-screen bg-[rgba(4,7,4,0.8)] flex flex-col justify-center items-center z-40">
      <div className="w-screen h-screen flex flex-col">
        <div className="flex items-center justify-between px-[48px] pt-6">
          <button onClick={onClose}>
            <img className="w-6 h-6 mr-4 object-contain" src={XIcon} alt="x" />
          </button>
          <p className="font-inter font-semibold text-base leading-6 text-white rounded-[8px] px-2 py-0.5 bg-[#040704]">
            {position + 1}
            <span className="text-[#686A68]">/{listImages?.length}</span>
          </p>
        </div>

        <div className="h-[calc(100vh-76px-128px)] flex items-center w-full justify-between px-[48px] py-6">
          <button disabled={position === 0} onClick={handlePrevImg}>
            <IArrowRounded2 />
          </button>
          <div className="w-[976.75px] h-[651.17px] object-contain flex justify-center items-center">
            <img src={img} alt="..." className="w-full h-full object-contain" />
          </div>
          <button disabled={position >= listImages?.length - 1} onClick={handleNextImg} className="transform rotate-180">
            <IArrowRounded2 />
          </button>
        </div>
        <div className="flex items-end justify-center gap-0.5 px-[48px] pb-6">
          {listImages?.map((item, idx) => (
            <ImageIndicator
              currentPosition={position}
              position={idx}
              src={item}
              alt={item}
              key={idx}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

const Wrapper = ({ isOpen, ...props }) => {
  if(!isOpen) return null;
  return (
    <ModalImages
      isOpen={isOpen}
      {...props}
    />
  );
}

export default Wrapper ;
